import { Link } from 'react-router-dom';
import { testimonials } from '@/mocks/site';

export default function Testimonials() {
  return (
    <section id="voices" className="w-full bg-secondary-50 border-y border-secondary-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.25em] text-secondary-700 mb-3">
              READERS / 读者怎么说
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              他们带着这份档案去看剧
            </h2>
          </div>
          <Link
            to="/about"
            className="self-start md:self-auto inline-flex items-center gap-2 text-sm text-secondary-800 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="h-full flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-secondary-200"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200">
                <p className="font-heading text-sm font-bold text-foreground-950">{item.name}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{item.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}